import { render } from "./DonateAnnouncement.vue?vue&type=template&id=26435f8d"
import script from "./DonateAnnouncement.vue?vue&type=script&lang=js"
export * from "./DonateAnnouncement.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__